import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { PbiDataset } from '../models';
import { pbiDatasetQueries } from './queries';

@Injectable({ providedIn: 'root' })
export class PbiDatasetRepositoryService extends RepositoryService<PbiDataset> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, pbiDatasetQueries.selectAll);
  }
}
